export default __webpack_public_path__ + "static/logo_var-bf0016e54235d3c2b6ac7203d0943a5d.png";